import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Container from "../ui/Container/Container";
import ButtonNovoProduto from "../ui/Button/ButtonNovoProduto";
import FormularioProduto from "./FormularioProduto"; // 👈 seu componente de formulário

export default function Produtos() {
  const [modoFormulario, setModoFormulario] = useState(false);

  return (
    <div className="flex flex-col items-start justify-start p-8">
      <h1
        className="text-3xl font-semibold text-gray-700 flex items-center gap-2"
        style={{
          fontFamily: '"Comfortaa", cursive',
        }}
      >
        Lista de Produtos 📦
      </h1>

      <div className="w-full mt-6">
        <Container>
          <AnimatePresence mode="wait">
            {!modoFormulario ? (
              // 🔹 LISTA DE PRODUTOS
              <motion.div
                key="lista"
                initial={{ x: 0, opacity: 1 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: "-100%", opacity: 0 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="flex flex-col w-full"
              >
                <div className="flex justify-end">
                  <ButtonNovoProduto
                    label="Novo Produto"
                    onClick={() => setModoFormulario(true)}
                  />
                </div>

                {/* Linha horizontal */}
                <hr
                  style={{
                    border: 0,
                    borderTop: "1px solid #a0a0a0",
                    width: "100%",
                    margin: "12px 0",
                  }}
                />

                {/* 🔹 Texto explicativo centralizado */}
                <div className="flex justify-center w-full mt-4">
                  <p
                    className="text-gray-700 text-lg text-center font-medium leading-relaxed max-w-2xl"
                    style={{
                      fontFamily: '"Comfortaa", cursive',
                    }}
                  >
                    ⚠️ Esta tela está parada no desenvolvimento. Está sendo
                    decidido com o <strong>Marcos</strong> como será feito o
                    fiscal dos produtos do nosso cliente.
                  </p>
                </div>

                {/* 👇 Aqui você pode manter sua tabela de produtos futuramente */}
              </motion.div>
            ) : (
              // 🔹 FORMULÁRIO DE CADASTRO (entra com animação)
              <motion.div
                key="formulario"
                initial={{ x: "100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: "100%", opacity: 0 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="flex flex-col w-full"
              >
                <FormularioProduto onVoltar={() => setModoFormulario(false)} />
              </motion.div>
            )}
          </AnimatePresence>
        </Container>
      </div>
    </div>
  );
}
